import { Col, Container, Row, Spinner } from "reactstrap";
import "../styles/index.css";
import { FaCheckCircle, FaCheckSquare } from "react-icons/fa";
import PlayerInfo from "pages/Joueurs/companents/PlayerInfo";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAnnounceDetails } from "store/slices/annonceSlice";
import { useEffect, useState } from "react";
import { getApplications } from "store/slices/applicationSlice";

const Details = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { id } = location.state || {};
  const { annonce, fetchLoading } = useSelector((state) => state.Annonce);
  const { applications, fetchLoading: lodingApplications } = useSelector((state) => state.Application);

  const [applicationsFilterd, setApplicationsFilterd] = useState(null);
  const [playersFromApplications, setPlayersFromApplications] = useState(null);
  useEffect(() => {
    if (id) {
      dispatch(getAnnounceDetails(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (annonce) {
      dispatch(getApplications());
    }
  }, [annonce, dispatch]);

  useEffect(() => {
    if (Array.isArray(applications?.applications)) {
      const filtered = applications.applications.filter((app) =>
        app.announcementId?._id === id
      );
      setApplicationsFilterd(filtered);
    }
  }, [applications, id]);

  const { t } = useTranslation();

  useEffect(() => {
    if (Array.isArray(applicationsFilterd)) {
      const extractedPlayers = applicationsFilterd
        .map(app => app.playerId)
      setPlayersFromApplications(extractedPlayers);
    }
  }, [applicationsFilterd]);

  return (
    <div className="page-content">
      <Container fluid style={{ maxWidth: "100%" }}>
        <div className="page-title-box" style={{ backgroundColor: "#F3F8F9" }}>
          {fetchLoading ? (
            <div style={{ textAlign: "center", padding: "20px" }}>
              <Spinner color="primary" />
            </div>
          ) : annonce ? (

            <Row>
              {/* En-tête (titre + code interne) */}
              <Row className="d-flex justify-content-center mb-4">
                <Col
                  md="11"
                  style={{
                    backgroundColor: "#EDF1F2",
                    paddingLeft: 15,
                    paddingRight: 15,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    maxHeight: 300,
                    minHeight: 50,
                  }}
                >
                  <div
                    style={{
                      font: "Poppins",
                      color: "#157088",
                      paddingLeft: "4%",
                    }}
                  >
                    {annonce.title}
                  </div>

                  <div
                    style={{
                      font: "Poppins",
                      color: "#157088",
                      paddingRight: "2%",
                      marginLeft: 10,
                    }}
                  >
                    {/* J’ai gardé « AN/45G12 » comme exemple de code ; adaptez si vous avez un champ spécifique */}
                    AN/45G12
                  </div>
                </Col>
              </Row>

              {/* INFO PRINCIPALE */}
              <Row className="d-flex justify-content-center">
                <Col md="10">
                  <Row>
                    <Col md="4">
                      {/* Title */}
                      <div style={{ marginBottom: 10 }}>
                        <span style={styles.titre}>{t("adDetails.title")}</span>
                        <span style={styles.info}> {annonce.title}</span>
                      </div>

                      {/* Position */}
                      <div style={{ marginBottom: 10 }}>
                        <span style={styles.titre}>{t("adDetails.position")}</span>
                        <span style={styles.info}> {annonce.position}</span>
                      </div>

                      {/* Catégorie (tableau de strings) */}
                      <div style={{ marginBottom: 15 }}>
                        <span style={styles.titre}>{t("adDetails.ageCategory")}</span>
                        <span style={styles.info}>
                          {" "}
                          {Array.isArray(annonce.category)
                            ? annonce.category.join(", ")
                            : annonce.category}
                        </span>
                      </div>
                    </Col>

                    <Col md="5">
                      {/* Région (par exemple « alger ») */}
                      <div style={{ marginBottom: 10 }}>
                        <span style={styles.titre}>{t("adDetails.region")}</span>
                        <span style={styles.info}> {annonce.region}</span>
                      </div>

                      {/* Localisation */}
                      <div style={{ marginBottom: 15 }}>
                        <span style={styles.titre}>{t("adDetails.location")}</span>
                        <span style={styles.info}> {annonce.location}</span>
                      </div>
                    </Col>

                    <Col md="3" className="col-align-lg-end">
                      {/* Status */}
                      <div style={{ marginBottom: 10 }}>
                        <span style={styles.titre}>{t("adDetails.status")}</span>
                        <span style={styles.info}> {annonce.status}</span>
                      </div>

                      {/* Date de créer (création/publication) */}
                      <div style={{ marginBottom: 10 }}>
                        <span style={styles.titre}>{t("adDetails.publishedOn")}</span>
                        <span style={styles.info}>
                          {" "}
                          {new Date(annonce.createdAt).toLocaleDateString()}
                        </span>
                      </div>

                      {/* Date de fin */}
                      <div style={{ marginBottom: 15 }}>
                        <span style={styles.titre}>{t("adDetails.endDate")}</span>
                        <span style={styles.info}>
                          {" "}
                          {new Date(annonce.endDate).toLocaleDateString()}
                        </span>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              {/* Séparateur */}
              <Row className="d-flex justify-content-center">
                <Col md="10">
                  <hr style={{ border: "1px solid black", opacity: "30%" }} />
                </Col>
              </Row>

              {/* DESCRIPTIONS ET LISTES */}
              <Row className="d-flex justify-content-center">
                <Col md="10">
                  <Row>
                    {/* Description */}
                    <Col md="4">
                      <h5 style={styles.sectionTitle}>
                        {t("adDetails.descriptionTitle")}
                      </h5>
                      <p style={styles.sectionText}>{annonce.description}</p>
                    </Col>

                    {/* Exigences (ici c’est une chaîne unique ou potentiellement un seul élément) */}
                    <Col md="4">
                      <h5 style={styles.sectionTitle}>
                        {t("adDetails.requirementsTitle")}
                      </h5>
                      <ul style={styles.sectionList}>
                        {Array.isArray(annonce.requirements)
                          ? annonce.requirements.map((exigence, index) => (
                            <li key={index} style={styles.sectionListItem}>
                              <span style={styles.pointBoldBlue}></span> {exigence}
                            </li>
                          ))
                          : annonce.requirements && (
                            <li style={styles.sectionListItem}>
                              <span style={styles.pointBoldBlue}></span> {annonce.requirements}
                            </li>
                          )}
                      </ul>
                    </Col>

                    {/* Bénéfices */}
                    <Col md="4" className="col-align-lg-end">
                      <h5 style={styles.sectionTitle}>
                        {t("adDetails.benefitsTitle")}
                      </h5>
                      <ul style={styles.sectionList}>
                        {Array.isArray(annonce.benefits) &&
                          annonce.benefits.map((avantage, index) => (
                            <li key={index} style={styles.advantageItem}>
                              <FaCheckSquare style={styles.checkIcon} /> {avantage}
                            </li>
                          ))}
                      </ul>
                    </Col>
                  </Row>
                </Col>
              </Row>

              {/* Section “Applications” (si vous la gardez) */}
              <Row className="d-flex justify-content-center">
                <Col md="11">
                  <div
                    style={{
                      marginTop: 35,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#EDF1F2",
                      color: "#157088",
                      height: 50,
                    }}
                  >
                    {t("adDetails.applications")}
                  </div>
                </Col>
              </Row>

              {/* Composant PlayerInfo (si vous en avez besoin) */}
              <Row className="d-flex justify-content-center">
                <Col md="11">
                  {
                    lodingApplications ? (
                      <div style={{ marginTop: 20, textAlign: "center" }}>
                        Chargement des joueurs...
                      </div>
                    ) : playersFromApplications?.length > 0 ? (
                      playersFromApplications.map((player) => (
                        <PlayerInfo player={player} key={player._id} />
                      ))
                    ) : (
                      <div style={{ marginTop: 20, textAlign: "center" }}>
                        Aucun joueur trouvé.
                      </div>
                    )
                  }

                </Col>
              </Row>
            </Row>

          ) : (
            <div style={{ marginTop: 20, textAlign: "center" }}>
              Aucune annonce trouvé.
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

export const styles = {
  titre: {
    font: "Poppins",
    color: "#000000",
    fontSize: 15,
    fontWeight: 500,
  },
  info: {
    color: "#000000",
    fontWeight: 300,
  },
  sectionTitle: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "#0B2839",
    marginTop: "10px",
    marginBottom: "20px",
  },
  sectionText: {
    fontSize: "14px",
    color: "#000",
  },
  sectionList: {
    listStyle: "none",
    padding: "0",
  },
  sectionListItem: {
    fontSize: "14px",
    color: "#000",
    marginBottom: "20px",
    display: "flex",
    alignItems: "center",
  },
  advantageItem: {
    display: "flex",
    alignItems: "center",
    marginBottom: "10px",
  },
  checkIcon: {
    color: "#157088",
    marginRight: "5px",
  },
  pointBoldBlue: {
    width: "8px",
    height: "8px",
    backgroundColor: "#157088",
    borderRadius: "50%",
    marginRight: "10px",
  },
};

export default Details;
